<template>
  <div>
    <div class="login-pass">{{$lang.messages.kid.login.pas_placeholder}}</div>
    <div class="kid-input-block" :class="{'-error' : errorpassword}">
      <input name="passName" type="password" class="input mb-0" @input="changePas($event.target.value)" :placeholder="$lang.messages.kid.login.pas_placeholder" @keyup.enter="$emit('gotodashboard')">
      <button class="btn btn-main" @click="$emit('gotodashboard')">{{$lang.messages.submit}}</button>
    </div>
    <div class="form-error" v-if="errorpassword">{{$lang.messages.kid.login.pas_error}}</div>
  </div>
</template>

<script>

export default {
  name: 'GoParentWithPassword',
  props: ['errorpassword'],
  methods: {
    changePas(value) {
      console.log(value);
      this.$emit('enterpas', value)
    }
  }
}

</script>
